import { useQuery } from '@apollo/client';
import { FILE_FORMATS_QUERY } from '../graphql/queries';
import { documentFormatsOf, type FileFormat } from '../utils/fileFormats';

/** The formats the Documents section accepts and what each opens in; `ready` once the server answered (or failed). */
export function useDocumentFormatsState(): { formats: FileFormat[]; ready: boolean } {
  const { data, loading } = useQuery(FILE_FORMATS_QUERY, { fetchPolicy: 'cache-first' });
  return { formats: documentFormatsOf(data?.fileFormats?.documents), ready: !loading };
}

/** The formats the Documents section accepts and what each opens in (PDF only until they load). */
export function useDocumentFormats(): FileFormat[] {
  return useDocumentFormatsState().formats;
}
